module.exports = __webpack_public_path__ + "static/cookie-7ef771c045d1693b97548fd02711a889.svg";